import { IconButton } from "@mui/joy";
import { useRecoilState } from "recoil";
import { layoutAtom } from "recoil/layoutAtom";

export default function SidebarTogglButton({
  direction = "left",
}: {
  direction?: "left" | "right";
}) {
  const [{ isLeftSideBarOpen, isRightSideBarOpen }, setLayoutState] =
    useRecoilState(layoutAtom);
  const isLeft = direction === "left";
  const key = isLeft ? "isLeftSideBarOpen" : "isRightSideBarOpen";

  const isSidebarOpen = isLeft ? isLeftSideBarOpen : isRightSideBarOpen;
  return window.location.pathname === "/" ? (
    <IconButton
      onClick={(e) => {
        if (isSidebarOpen) {
          setLayoutState((state) => ({ ...state, [key]: false }));
        } else {
          setLayoutState((state) => ({ ...state, [key]: true }));
        }
      }}
      variant="plain"
      color="neutral"
      size="sm"
      sx={{ transform: !isLeft ? "rotate(180deg)" : undefined }}
    >
      {isSidebarOpen ? (
        <span className="material-symbols-outlined">left_panel_close</span>
      ) : (
        <span className="material-symbols-outlined">dock_to_right</span>
      )}
    </IconButton>
  ) : (
    <></>
  );
}
